import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from '../../../store';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import Select2Multiple from "v-select2-multiple-component";
import {
    required,
    maxLength,
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "HolidayCreate",
    components: {
        MainLayout,
        flatPickr,
        Loading,
        Select2Multiple,
    },

    data() {
        return {
            isLoading: false,
            holidayData: {
                date: "",
                description: "",
                type: 1,
                category_id: 1,
                is_day_off: 0,
            },
            typeArr: null,
            categoryArr: null,
            submitted: false,
            disabled: false,
            holidayTypeValid: true,
            holidayCategoryValid: true,
        };
    },
     watch: {
         'holidayData.type': {
             immediate: true,
             handler: function(newVal) {
                 if (Number(newVal) !== 3) {
                     this.holidayData.is_day_off = 1;
                 }
             }
         }
     },

    computed: {
        categorySelectSettings() {
            return {
                multiple: false,
                placeholder: "Choose Category",
                escapeMarkup: (markup) => markup,
                templateResult: (data) => this.categoryOptionHtml(data),
                templateSelection: (data) => this.categoryOptionHtml(data),
            };
        },
    },

    validations: {
        holidayData: {
            date: {
                required
            },
            description: {
                maxLength: maxLength(1000)
            },
        },
        holidayTypeValid: {
            typeFromConfig() {
                const value = this.holidayData.type;
                if (value === "" || value === null || value === undefined || Number(value) === 0) {
                    return true;
                }
                const n = Number(value);
                if (Number.isNaN(n)) {
                    return false;
                }
                return CONFIG.HOLIDAY_TYPE_OPTIONS[n] !== undefined;
            },
        },
        holidayCategoryValid: {
            categoryFromConfig() {
                const value = this.holidayData.category_id;
                if (value === "" || value === null || value === undefined || Number(value) === 0) {
                    return true;
                }
                const n = Number(value);
                if (Number.isNaN(n)) {
                    return false;
                }
                const opts = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
                return opts.some((o) => Number(o.id) === n);
            },
        },
        holidayIsDayOffValid: {
            dayOffRequiredForNonEventTypes() {
                const type = Number(this.holidayData.type);
                const isDayOff = this.holidayData.is_day_off;
                
                // For non-event types (1, 2), is_day_off must be 1 (true)
                if (type !== 3) {
                    return isDayOff === 1 || isDayOff === "1";
                }
                
                // For event type (3), no restriction - can be 0 or 1
                return true;
            }
        }
    },

    methods: {
        holidayCategorySwatchColor(colorCode) {
            if (typeof colorCode === "string" && /^#[0-9A-Fa-f]{6}$/.test(colorCode)) {
                return colorCode;
            }
            return "#94a3b8";
        },

        categoryOptionHtml(data) {
            if (!data || data.id === undefined || data.id === null || data.id === "") {
                return "";
            }
            if (Number(data.id) === 0) {
                return data.text != null ? String(data.text) : "";
            }
            const id = Number(data.id);
            const opt = (CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || []).find(
                (o) => Number(o.id) === id
            );
            const rawLabel =
                data.text != null && String(data.text) !== ""
                    ? String(data.text)
                    : opt && opt.label
                      ? String(opt.label)
                      : "";
            const color = this.holidayCategorySwatchColor(
                (opt && opt.color_code) || data.color_code
            );
            const escaped = rawLabel
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;");
            return (
                '<span class="holiday-category-select-row" style="display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;">' +
                '<span class="holiday-category-select-row__txt" style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' +
                escaped +
                "</span>" +
                '<span class="holiday-category-select-row__swatch" style="flex-shrink:0;width:14px;height:14px;border-radius:3px;background-color:' +
                color +
                ';border:1px solid rgba(0,0,0,0.15);" aria-hidden="true"></span>' +
                "</span>"
            );
        },

        appendOptionalHolidayFields(payload) {
            const data = this.holidayData;
            if (
                data.type !== "" &&
                data.type !== null &&
                data.type !== undefined &&
                Number(data.type) !== 0
            ) {
                payload.type = Number(data.type);
            }
            const cat = data.category_id;
            if (
                cat !== "" &&
                cat !== null &&
                cat !== undefined &&
                Number(cat) !== 0
            ) {
                payload.category_id = Number(cat);
            }
            if (data.is_day_off === 1 || data.is_day_off === "1") {
                payload.is_day_off = true;
            } else if (data.is_day_off === 0 || data.is_day_off === "0") {
                payload.is_day_off = false;
            }
        },

        async confirmRegister() {
            if (this.disabled) return;
            this.submitted = true;
            this.disabled = true;
            if (this.$v.$invalid || this.holidayData.date == '' || this.holidayData.date == 0) {
                this.disabled = false;
                return;
            }
            this.register();
        },

        register() {
            this.disabled = true;
            var request = {
                date: this.holidayData.date,
                description: this.holidayData.description,
                login_id: store.state.user.id,
                campus_id: store.state.user.campus_id,
            };
            this.appendOptionalHolidayFields(request);

            axios.post("/holiday/create", request, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.success == true) {
                        this.$notification.success("Holiday Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        if (this.$route.query.rd_back == 'holiday') {
                            this.$router.push({
                                name: "holidayCreate"
                            });
                        } else {
                            this.$router.push({
                                name: "holidayList"
                            });
                        }
                    } else {
                        this.disabled = false;
                        this.$notification.error(response.data.message, {
                          timer: 3,
                          position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.disabled = false;
                    const message =
                        error.response?.data?.message ||
                        error.response?.data?.errors?.exception ||
                        "Failed to create holiday";
                    console.log("Holiday Create API Error", message);
                    this.$notification.error(message, {
                        timer: 3,
                        position: "bottomCenter",
                    });
                });
        },

        getHolidayType() {
            const result = [];
            Object.entries(CONFIG.HOLIDAY_TYPE_OPTIONS).forEach(([id, key]) => {
                result.push({
                    id: id,
                    text: key,
                });
            });
            this.typeArr = result;
        },

        getHolidayCategoryOptions() {
            const result = [];
            Object.entries(CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || []).forEach(
                ([, opt]) => {
                    result.push({
                        id: opt.id,
                        text: opt.label,
                        color_code: opt.color_code,
                    });
                }
            );
            this.categoryArr = result;
        },

        showList() {
            this.$router.push({
                path: "/holiday/list"
            });
        },
    },

    mounted() {
        this.getHolidayType();
        this.getHolidayCategoryOptions();
    },
};
